const FOOTER = {
  INFO: 'Promobit Servicos de Tecnologia Digital Ltda - CNPJ 23.895.251/0001-87',
  ADDRESS: 'R. Emilio Mallet 317, sala 1403, São Paulo - SP.',
  COPYRIGHT: `© Promobit 2014-${new Date().getUTCFullYear()}`,
  WHAT_IS: {
    TITLE: 'O que é o Promobit',
    DESCRIPTION:
      'Somos mais de 1 milhão de apaixonados por economizar. Juntos compartilhamos em média 700 promoções e cupons por dia. Participe da comunidade!',
  },
  INSTITUTIONAL: {
    TITLE: 'Institucional',
    PAGES: {
      ABOUT_US: 'Sobre nós',
      BUSINESS: 'Comercial',
      CONTACT_US: 'Fale conosco',
      CAREERS: 'Trabalhe conosco',
      MEDIA: 'Promobit na Mídia',
    },
  },
  SECURE_SITE: {
    TITLE: 'Site Seguro',
    GOOGLE_SAFE_BROWSING_ALT: 'Certificado Google Safe Browsing',
    GOOGLE_FOR_STARTUPS_ALT: 'Certificado Google for Startups Accelerator 2020',
  },
  SPECIAL_PAGES: {
    TITLE: 'Páginas Especiais',
    PAGES: {
      BLACK_FRIDAY: 'Black Friday',
      AMERICANAS_COUPONS: 'Cupons Americanas',
      SMARTPHONE_DEALS: 'Celulares em promoção',
      EARPHONE_DEALS: 'Fones de ouvido em promoção',
      GAMES_DEALS: 'Games em promoção',
      FRIDGE_DEALS: 'Geladeiras em promoção',
      PONTOFRIO_COUPONS: 'Cupons Pontofrio',
      PAMPERS_NAPPIES_DEALS: 'Fralda Pampers em promoção',
      TV_DEALS: 'TVs em promoção',
      SUBMARINO_COUPONS: 'Cupons Submarino',
    },
  },
  BETA_TESTER: {
    BE_A_TESTER: 'Seja um beta tester',
    TITLE: 'Quer testar as novidades?',
  },
  HELP: {
    TITLE: 'Artigos de Ajuda',
    ARTICLES: {
      COMMUNITY_GUIDELINES: 'Diretrizes da comunidade',
      MOD_CRITERIA: 'Critérios de moderação',
      FAQ: 'Perguntas frequentes',
      PURCHASE_ISSUES: 'Problemas com sua compra?',
    },
  },
  PAGES: {
    WHAT_IS: 'O que é o Promobit?',
    BLACK_FRIDAY: 'Black Friday',
    BUSINESS: 'Comercial',
    RATE_PROMOBIT: 'Avalie o Promobit',
    USE_TERMS: 'Termos de Uso',
    PRIVACY: 'Política de Privacidade',
    COOKIES: 'Política de Cookies',
    SITEMAP: 'Mapa Site',
  },
  CASH3: {
    TITLE: 'Empresas do Grupo CASH3',
    PAGES: {
      PROMOBIT: 'Promobit',
      IDINHEIRO: 'iDinheiro',
      MELIUZ: 'Méliuz',
      MELHOR_PLANO: 'Melhor Plano',
      MINHA_CONEXAO: 'Minha Conexão',
      PICODI_BR: 'Picodi Br',
    },
  },
};

export default FOOTER;
